export { GeminiClient } from './gemini-client'
export type { GeminiConfig, GeminiRequest, GeminiResult, GeminiContent, GeminiPart, GeminiFunctionDeclaration } from './gemini-client'
export { ToolCallbackHandler } from './tool-callback'
export { buildFunctionDeclarations, ACTION_SCHEMAS } from './function-declaration'
export { registerAgentLoopAction, agentLoop } from './agent-loop'
export type { AgentLoopOptions, AgentLoopResult, AgentLoopActionEngine } from './agent-loop'
